import { makeStyles } from '@mui/styles';
import { NextTheme } from '../../../../../../layout/theme-next/provider';

export default makeStyles<NextTheme>((theme) => ({
  previewTabContent: {
    paddingBottom: theme.spacing(1.5),
  },
  previewTabPanel: {
    marginRight: theme.spacing(-2),
  },
}));
